module.exports = __webpack_public_path__ + "img/FCST-Image.c374a9e0.png";